import { articleUrls } from "@clockwise/client-commons/src/constants/help-center";
import { Link } from "@clockwise/design-system";
import { Sparkle } from "phosphor-react";
import React from "react";

type Props = {
  onFlexibilityFaqSelect?: () => void;
};

export const FlexibilityLearnMore = ({ onFlexibilityFaqSelect }: Props) => {
  return (
    <div
      className="cw-caption cw-flex cw-items-center cw-gap-1"
      onClick={() => {
        onFlexibilityFaqSelect && onFlexibilityFaqSelect();
      }}
    >
      <Sparkle size={14} />
      <Link href={articleUrls.flexibilityFaq} target="_blank" cw-id="flexibility-learn-more-link">
        What meetings should I mark flexible?
      </Link>
      <Sparkle size={14} />
    </div>
  );
};
